import React from "react";
import { OfferingDetail } from "../components/OfferingDetail";
export default function FactoryPage({ onDemo }) { return <OfferingDetail slug="factory" onDemo={onDemo} />; }